import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { SharedService } from '../../../services/shared.service';

@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [RouterModule, MatTooltipModule],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
})
export class BreadcrumbsComponent {
  @Input() routeData: any;
  projectNameShort: string = '';
  fullProjectName: string = '';
  urlDomain: any;
  projectId: any;
  breadcrumbs: { label: string; url: string }[] = [];
  routeFrom: any;
  routeFromSubConf: any;

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        // this.updateBreadcrumbs();
      });
  }

  ngOnInit() {
    this.loadProjectName();
    console.log('routeData', this.routeData);
    this.urlDomain = localStorage.getItem('urlDomain');
    console.log('this.urlDomain', this.urlDomain);
    this.projectId = localStorage.getItem('projectId');
    console.log('this.projectId ', this.projectId);
    //  this.fullProjectName = localStorage.getItem('projectName');
    //  console.log('this.fullProjectName', this.fullProjectName);
    this.routeFrom = localStorage.getItem('routeFrom');
    this.routeFromSubConf = localStorage.getItem('routeFromSubConf');
    // this.projectNameShort = this.fullProjectName;
    // if (this.fullProjectName.length > 10) {
    //   this.projectNameShort = this.fullProjectName.substring(0, 10) + '...';
    // }
    // this.fullProjectName = this.fullProjectName;
    // this.projectNameShort = this.projectNameShort;

    // this.updateBreadcrumbs(this.projectNameShort);
  }

  loadProjectName() {
    const interval = setInterval(() => {
      const name = localStorage.getItem('projectName');
      if (name) {
        this.fullProjectName = name;
        this.projectNameShort =
          name.length > 10 ? name.substring(0, 10) + '...' : name;
        this.updateBreadcrumbs(this.projectNameShort);
        this.cdr.detectChanges(); // Trigger change detection
        clearInterval(interval); // Stop polling
      }
    }, 300); // Check every 300ms
  }

  // before Sonar

  // updateBreadcrumbs(projectNameShort: string) {
  //   console.log('projectNameShort', projectNameShort);
  //   console.log('route data', this.routeData);
  //   const currentUrl = this.router.url.split('/').filter(Boolean);
  //   this.breadcrumbs = [];

  //   const baseBreadcrumbs = [
  //     { label: projectNameShort, url: '/' },
  //     { label: 'Enter', url: '/home' },
  //     { label: 'Preview', url: '/preview' },
  //     { label: 'Results', url: '/result' },
  //     { label: 'Assess Risk', url: '/ira' },
  //     { label: 'Confirmation', url: '/confirmation' },
  //     { label: 'Confirmation', url: '/ira-confirmation' },
  //     { label: 'Results', url: '/editclaims' },
  //     { label: 'Confirmation', url: '/substantiation-confirmation' },
  //   ];

  //   const curUrl = localStorage.getItem('routeFrom');
  //   console.log('currentUrl', curUrl);
  //   if (currentUrl.includes('editclaims')) {
  //     this.breadcrumbs.push(
  //       baseBreadcrumbs[0],
  //       baseBreadcrumbs[1],
  //       baseBreadcrumbs[7]
  //     );
  //   } else if (currentUrl.includes('ira-confirmation')) {
  //     if (this.routeFrom == 'ira') {
  //       this.breadcrumbs.push(
  //         baseBreadcrumbs[0],
  //         baseBreadcrumbs[1],
  //         baseBreadcrumbs[2],
  //         baseBreadcrumbs[4],
  //         baseBreadcrumbs[3],
  //         baseBreadcrumbs[5]
  //       );
  //     } else if (this.routeFrom == 'editClaims') {
  //       console.log('EditClaims flow detected');
  //       // EditClaims flow
  //       this.breadcrumbs.push(
  //         baseBreadcrumbs[0],
  //         baseBreadcrumbs[1],
  //         baseBreadcrumbs[3],
  //         baseBreadcrumbs[5]
  //       );
  //     } else {
  //       this.breadcrumbs.push(
  //         baseBreadcrumbs[0],
  //         baseBreadcrumbs[1],
  //         baseBreadcrumbs[2],
  //         baseBreadcrumbs[3],
  //         baseBreadcrumbs[5]
  //       );
  //     }
  //   }
  //   // else if (currentUrl.includes('confirmation')) {
  //   //   this.breadcrumbs.push(
  //   //     baseBreadcrumbs[0],
  //   //     baseBreadcrumbs[1],
  //   //     baseBreadcrumbs[2],
  //   //     baseBreadcrumbs[3],
  //   //     baseBreadcrumbs[5]
  //   //   );
  //   // }
  //   else if (currentUrl.includes('confirmation')) {
  //     if (this.routeFrom == 'editClaims') {
  //       console.log('EditClaims flow detected');
  //       // EditClaims flow
  //       this.breadcrumbs.push(
  //         baseBreadcrumbs[0],
  //         baseBreadcrumbs[1],
  //         baseBreadcrumbs[3],
  //         baseBreadcrumbs[5]
  //       );
  //     } else {
  //       // Regular confirmation flow
  //       this.breadcrumbs.push(
  //         baseBreadcrumbs[0],
  //         baseBreadcrumbs[1],
  //         baseBreadcrumbs[2],
  //         baseBreadcrumbs[3],
  //         baseBreadcrumbs[5]
  //       );
  //     }
  //   } else if (currentUrl.includes('ira')) {
  //     this.breadcrumbs.push(
  //       baseBreadcrumbs[0],
  //       baseBreadcrumbs[1],
  //       baseBreadcrumbs[2],
  //       baseBreadcrumbs[4]
  //     );
  //   } else if (currentUrl.includes('result')) {
  //     if (this.routeFrom == 'editClaims') {
  //       this.breadcrumbs.push(baseBreadcrumbs[0], baseBreadcrumbs[3]);
  //     } else if (this.routeFrom == 'ira') {
  //       this.breadcrumbs.push(
  //         baseBreadcrumbs[0],
  //         baseBreadcrumbs[1],
  //         baseBreadcrumbs[2],
  //         baseBreadcrumbs[4],
  //         baseBreadcrumbs[3]
  //       );
  //     } else {
  //       this.breadcrumbs.push(
  //         baseBreadcrumbs[0],
  //         baseBreadcrumbs[1],
  //         baseBreadcrumbs[2],
  //         baseBreadcrumbs[3]
  //       );
  //     }
  //   } else if (currentUrl.includes('preview')) {
  //     this.breadcrumbs.push(
  //       baseBreadcrumbs[0],
  //       baseBreadcrumbs[1],
  //       baseBreadcrumbs[2]
  //     );
  //   } else if (currentUrl.includes('home')) {
  //     this.breadcrumbs.push(baseBreadcrumbs[0], baseBreadcrumbs[1]);
  //   } else if (currentUrl.includes('substantiation-confirmation')) {
  //     this.breadcrumbs.push(
  //       baseBreadcrumbs[0],
  //       baseBreadcrumbs[1],
  //       baseBreadcrumbs[2],
  //       baseBreadcrumbs[3],
  //       baseBreadcrumbs[5]
  //     );
  //   } else {
  //     this.breadcrumbs.push(baseBreadcrumbs[0]);
  //   }
  // }

  // After Sonar
  updateBreadcrumbs(projectNameShort: string) {
    const currentUrl = this.router.url.split('/').filter(Boolean);
    console.log(currentUrl, 'currentUrl breadcrumbs');
    const routeFrom = this.routeFrom;
    console.log(routeFrom, 'routeFrom routeFrom breadcrumbs');
    this.breadcrumbs = [];

    const baseBreadcrumbs = [
      { label: projectNameShort, url: '/' }, // 0
      { label: 'Enter', url: '/home' }, // 1
      { label: 'Preview', url: '/preview' }, // 2
      { label: 'Results', url: '/result' }, // 3
      { label: 'Assess Risk', url: '/ira' }, // 4
      { label: 'Confirmation', url: '/confirmation' }, // 5
      { label: 'Confirmation', url: '/ira-confirmation' }, // 6
      { label: 'Results', url: '/editclaims' }, // 7
      { label: 'Confirmation', url: '/substantiation-confirmation' }, // 8
    ];

    const pushBreadcrumbs = (...indices: number[]) => {
      this.breadcrumbs.push(...indices.map((i) => baseBreadcrumbs[i]));
    };

    const urlIncludes = (segment: string) => currentUrl.includes(segment);

    const routeConfig: { [key: string]: () => number[] } = {
      editclaims: () => [0, 1, 7],
      'ira-confirmation': () => {
        if (routeFrom === 'ira') return [0, 1, 2, 4, 3, 5];
        if (routeFrom === 'editClaims' || routeFrom === 'iraResult')
          return [0, 1, 3, 5];
        return [0, 1, 2, 3, 5];
      },
      confirmation: () =>
        routeFrom === 'editClaims' ? [0, 1, 3, 5] : [0, 1, 2, 3, 5],
      ira: () => [0, 1, 2, 4],
      result: () => {
        if (routeFrom === 'editClaims' || routeFrom === 'iraResult')
          return [0, 1, 3];
        if (routeFrom === 'ira') return [0, 1, 2, 4, 3];
        if (routeFrom === 'IRAeditclaims') return [0, 1, 3];
        if (routeFrom === 'subEdit' || this.routeFromSubConf === 'editClaims')
          return [0, 1, 3];
        return [0, 1, 2, 3];
      },
      preview: () => [0, 1, 2],
      home: () => [0, 1],
      'substantiation-confirmation': () => {
        if (this.routeFromSubConf === 'editClaims') return [0, 1, 3, 5];
        return [0, 1, 2, 3, 5];
      },
    };

    for (const key in routeConfig) {
      if (urlIncludes(key)) {
        pushBreadcrumbs(...routeConfig[key]());
        return;
      }
    }

    // Default case
    pushBreadcrumbs(0);
  }

  navigateTo(url: string) {
    console.log('url', url);
    console.log('routeData', this.routeData);
    if (this.routeData) {
      if (url === '/ira') {
        if (!this.routeData) {
          this.routeData = this.sharedService.getRouteData();
        }
        console.log('this.routeData', this.routeData);

        this.router.navigate([url], {
          // state: {
          //   data: this.routeData.docDetails.currentPage,
          //   document: this.routeData.docDetails.document,
          //   marketingChannels: this.routeData.marketingChannels,
          //   pageno: 0,
          // },
          state: {
            fileDetails: this.routeData.fileDetails,
            data: this.routeData.resultData,
            resultPageTableData: [],
            isExcel: false,
            flow: 'normal',
            pageFrom: 'preview',
            fileBase64: {
              document: this.routeData.docDetails.document,
              currentPage: this.routeData.docDetails.currentPage,
            },
          },
        });
      } else if (url === '/result') {
        console.log('this.routeFrom', this.routeFrom);
        console.log('this.routeFrom', this.routeData.resultData);
        if (this.routeFrom === 'editClaims') {
          this.router.navigate(['editclaims'], {
            state: {
              data: this.routeData.resultData,
              fileDetails: this.routeData.fileDetails,
              isExcel: false,
              routeFrom: this.routeFrom,
            },
          });
        } else if (this.routeFrom === 'ira' || this.routeFrom === 'iraResult') {
          let resultsData = [];
          resultsData.push({
            claims_la: [],
            fileBase64: this.routeData.resultData.fileBase64data,
            new_qualifiers: [],
            iRA_button_enable: true,
            new_marketing_channels: [],

            iraresultsdata: this.routeData.resultData, // Only Label=text entries
          });
          console.log('resultsData', resultsData);
          this.router.navigate([url], {
            state: {
              data: resultsData,
              fileDetails: this.routeData.fileDetails,
              marketingChannels: this.routeData.marketingChannels,
              isExcel: false,
              pageFrom: 'ira',
            },
          });
        } else {
          this.router.navigate([url], {
            state: {
              data: this.routeData.resultData,
              fileDetails: this.routeData.fileDetails,
              marketingChannels: this.routeData.marketingChannels,
              isExcel: false,
              routeFrom: this.routeFrom,
            },
          });
        }
      } else if (url === '/preview') {
        this.router.navigate([url], {
          state: {
            data:
              this.routeData.docDetails.currentPage ||
              this.routeData.docDetails[0].currentPage,
            document:
              this.routeData.docDetails.document ||
              this.routeData.docDetails[0].document,
            marketingChannels: this.routeData.marketingChannels,
            fileDetails: this.routeData.fileDetails,
            pageno: 0,
          },
        });
      } else if (url === '/home') {
        this.router.navigate([url]);
      }
    } else {
      this.router.navigate([url]);
    }
  }

  // getProjectId() {
  //   let projectId = 'V2C00000000F002';
  //   localStorage.setItem('projectId', projectId);
  //   console.log('this.projectId ', this.projectId);
  // }
}
